import React from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import testimonialLogos from '../assets/images/testimonial-logos.jpg';


function BusinessTestimonial(props) {
  const {classes} = props;

  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <div className="col-md-8 text-center">
          <h2 className={classes.testimonialHeadline}>Businesses trust SingleShift to find staff.</h2>
        </div>
      </div>
      <div className="row text-center justify-content-md-center">
        <div className="col-md-10">
          <img className={`${classes.testimonialImage} img-fluid`} src={testimonialLogos}/>
        </div>
      </div>
    </div>
  )
}

const styles = (theme) => ({
  testimonialHeadline: {
    marginBottom: '30px',
  },
});

export default withStyles(styles)(BusinessTestimonial);



// WEBPACK FOOTER //
// ./src/parts/BusinessTestimonial.js